import { AppError } from '@lessonup/utils-support';
import { LogDetails } from './IsomorphicLogger';
import { SentryEditorScope, SentryPlayerScope } from './logger.utils';
import { LoggerTransport, TraceCategory } from './loggerTransport';

export const errorIsPassableToLogger = (error: unknown): error is ErrorMessage => {
  return error instanceof Error || error instanceof AppError || typeof error === 'string';
};

export type ErrorMessage = AppError | Error | string;

export class Logger implements LoggerTransport {
  private transports: LoggerTransport[] = [];

  public registerTransport(transport: LoggerTransport): void {
    this.transports.push(transport);
  }

  public debug(message: string, details: LogDetails): void {
    this.transports.forEach((transport) => transport.debug?.(message, details));
  }

  public info(message: ErrorMessage, details?: LogDetails): void {
    this.transports.forEach((transport) => transport.info?.(message, details));
  }

  public warn(message: ErrorMessage, details?: LogDetails): void {
    this.transports.forEach((transport) => transport.warn?.(message, details));
  }

  public error(message: ErrorMessage, details?: LogDetails): void {
    this.transports.forEach((transport) => transport.error?.(message, details));
  }

  public setUserId(userId: string | undefined): void {
    this.transports.forEach((transport) => transport.setUserId?.(userId));
  }

  public trace(category: TraceCategory, message: string): void {
    this.transports.forEach((transport) => transport.trace?.(category, message));
  }

  public setEditorScope(sentryEditorScope: SentryEditorScope | null): void {
    this.transports.forEach((transport) => transport.setEditorScope?.(sentryEditorScope));
  }

  public setPlayerScope(sentryPlayerScope: SentryPlayerScope | null): void {
    this.transports.forEach((transport) => transport.setPlayerScope?.(sentryPlayerScope));
  }
}

export const logger = new Logger();
